import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import BottomSwish from "../images/bottom-swish.svg";
import ENews from "../components/widgets/enews";
import Weather from "./weather";

const Footer = () => (
  <StaticQuery
    query={graphql`
    query {
        site {
            siteMetadata {
                fullname
            }
        }
    }
    `}
    render={data => (
      <>
        <img src={BottomSwish} className="w-full -mb-1 " />
        <footer className="bg-bggreen text-bgmint px-12 py-12 font-[400]">
          <div className="relative container max-w-8xl mx-auto">
            <div className="md:flex justify-between items-top mb-0">
              <div className="mb-2 md:mb-0 text-center md:text-left">
                <Weather />
              </div>
              <div className="text-3xl">
                <ENews />
              </div>
            </div>
            <div className="md:flex justify-between items-end text-lg text-center md:text-left">
              <div className="mb-4 md:mb-0">
                <div className="mb-4 text-sm font-light">
                  VISIT OUR WEBSITE:
                  <a target="_blank" rel="noopener noreferrer" href="https://bridgestonemud.com/">
                    <svg fill="currentColor" className="h-10 w-40 mx-auto md:mr-auto md:ml-0">
                      <use xlinkHref={`#bridgestone`}></use>
                    </svg>
                  </a>
                </div>
                <p className="mb-1 font-[300]">&copy; {new Date().getFullYear()} <span className="font-[500]">Bridgestone MUD Park</span> &amp; <span className="font-[500]">Bridgestone MUD</span></p>
                <p><Link className="opacity-50 text-sm hover:text-white" to="/legal-notices-and-disclaimers">Legal Notices & Disclaimers</Link>
                </p>
                <p className="opacity-50 text-sm font-[200]">Park design by Tomball-based company <a className="text-inherit hover:text-white font-[400]" href="https://www.4and1design.com/" target="_blank" rel="noopener noreferrer">FOUR AND ONE</a></p>
                <p className="opacity-50 text-xs font-[200]">Website provided by <a className="text-inherit hover:text-white font-[400]" href="https://www.touchstonedistrictservices.com/" target="_blank" rel="noopener noreferrer">Touchstone</a></p>
              </div>
              <div>
                <p className="mb-1">Follow us on Facebook</p>
                <a className="inline-block hover:text-white" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61578956278805"><svg fill="currentColor" className="w-8 h-8">
                  <use xlinkHref={`#facebook`}></use>
                </svg>
                </a>
              </div>
            </div>
          </div>
        </footer>
      </>
    )} />
)

export default Footer
